export default "__VITE_ASSET__DlQUkcwN__"